import { client } from "../../client";
import { MeterReading } from "../../meters";

export interface MeterPointReadings {
  results: Array<{
    meterId: string;
    readings: MeterReading[];
  }>;
}
export const getMeterPointReadings = (
  queryKey: string,
  meterPointId: number | string,
) => {
  return client
    .get<MeterPointReadings>(`meterpoints/${meterPointId}/readings`)
    .then((response) => response.data.results);
};

export const saveMeterReading = ({
  accountNumber,
  values,
  ignoreWarnings = false,
}: {
  accountNumber: string;
  values: Record<string, any>;
  ignoreWarnings?: boolean;
}) => {
  return client.post(
    `accounts/${accountNumber}/readings?ignoreWarning=${ignoreWarnings}`,
    // `accounts/${accountNumber}/readings?ignoreWarning=${ignoreWarnings}&shouldError=${!ignoreWarnings}`, // DEV
    {
      meters: values,
    },
  );
};
